export default __webpack_public_path__ + "static/media/yoga.3672dcfe.png";